import { BankAccountInterface } from "../PaymentInterface";

export interface BankAccountDTO {
  bankID: number;
  bank: string;
  bankAccountID: number;
  accountCode: string;
  accountNumber: string;
  accountDescription: string;
  accountTypeName: string;
  bankAccountTypeID: number;
  bankTypeName: string;
  currencyID: number;
  currencyName: string;
  currencyIsoCode: string;
}

export const bankAccountList: BankAccountInterface[] = [
  {
    bankAccountID: 0,
    bankID: 0,
    bankName: "No procesado",
  },
  {
    bankAccountID: 1,
    bankID: 4,
    bankName: "Mercantil (0740)",
  },
  {
    bankAccountID: 11,
    bankID: 6,
    bankName: "Bancaribe (7628)",
  },
  {
    bankAccountID: 12,
    bankID: 9,
    bankName: "Banesco (2750)",
  },
  {
    bankAccountID: 14,
    bankID: 26,
    bankName: "BNC (9313)",
  },
  {
    bankAccountID: 17,
    bankID: 5,
    bankName: "Provincial (0193)",
  },
  {
    bankAccountID: 19,
    bankID: 18,
    bankName: "Bancrecer (5747)",
  },
  {
    bankAccountID: 45,
    bankID: 9,
    bankName: "Banesco (0539)",
  },
  {
    bankAccountID: 46,
    bankID: 13,
    bankName: "BFC (5027)",
  },
];